import { useQuery } from '@tanstack/react-query';
import { requestSavedPaymentMethods, savedPaymentMethodsKey, selectAllPaymentAccounts } from './paymentApi';

/**
 * Every saved payment account, cards and bank accounts together, for flows that can charge either.
 *
 * Cross-cutting like `useSetDefaultPaymentMethod`, so it lives at the top level rather than in a
 * per-domain folder. Shares `savedPaymentMethodsKey` with the card- and bank-only hooks, so mounting
 * it alongside them still fires `mySavedPaymentMethods` once.
 */
export function useSavedPaymentAccounts() {
  return useQuery({
    queryKey: savedPaymentMethodsKey,
    queryFn: requestSavedPaymentMethods,
    select: selectAllPaymentAccounts,
  });
}
